const paperLangs = {
  outsourceList: {
    title: "Danh sách gia công",
  },
  outsourceAdd: {
    title: "Thêm gia công",
  },
  error: {
    outsourceList: "lấy danh sách gia công lỗi",
    outsourceAdd: "Thêm gia công bị lỗi",
    outsourceUpdate: "Cập nhật gia công lỗi",
    outsourceDelete: "Xoá gia công lỗi",
  },
  success: {
    outsourceAdd: "Thêm gia công thành công",
    outsourceUpdate: "Cập nhật gia công thành công",
    outsourceDelete: "Xoá gia công thành công",
  },
};

export default paperLangs;
